import { api } from "@/services/api/createAPI";
import { getAuthToken } from "@/services/supabase/auth/actions/getAuthToken";
import { getUserId } from "@/services/supabase/auth/actions/getUserId";
import { supabase } from "@/services/supabase/createClient";
import { SemanticModel } from "@pufflig/prompt-studio-types";

export const setupSemanticModel = async (connectorId: string, teamId?: string): Promise<string> => {
  const ownerId = teamId || (await getUserId());
  const token = await getAuthToken();

  const result = await api(token).post("/api/semantic/connector", { connectorId: connectorId });
  const { semanticModel } = result.data as { semanticModel: SemanticModel };

  const { data, error } = await supabase.rpc("create_semantic_model", {
    p_name: semanticModel.name,
    p_description: semanticModel.description,
    p_model: semanticModel as any,
    owner_id: ownerId,
    p_connector_id: connectorId,
  });

  if (error) {
    throw new Error(`Error creating base semantic model: ${error.message}`);
  }

  return data;
};
